import React from "react";
import { ReactComponent as TuringLogoText }  from "../../../../../../assets/img/turing_logo_text.svg"
import { Button, KIND } from "baseui/button";
import { useDispatch } from "react-redux";
import DrawerActions from "../../../../../../actions/Drawer";
import { PageConstant } from "../../../../../../constants";
import "./Header.scss";

const HeaderV2 = () => {
  const dispatch = useDispatch();
  const currentUrl = window.location.href;
  const handleExit = () => {
    if (currentUrl.includes(PageConstant.VETSMITH_PAGE) || currentUrl.includes('specialized-vetting')) {
        dispatch(DrawerActions.exitVetsmith(true));
    }
    window.location.href = PageConstant.JOB_PAGE;
  };
  const width = window.innerWidth
  return (
    <header className="turing-mobile-home-header">
      <div className="turing-mobile-home-header__main-section">
        <div><TuringLogoText style={{ width: '120px', height: 'auto' }} /></div>
        <div>
          <Button 
            className="exit-vetsmith" 
            kind={KIND.tertiary} 
            onClick={handleExit}
          >
            Go back to {width < 744 ? 'Dev' : 'the Developer' } Portal
          </Button>
        </div>
      </div>
    </header>
  );
};

export default HeaderV2;
